import { render, staticRenderFns } from "./drawRadarCanvas2v.vue?vue&type=template&id=03a36fcd&scoped=true&"
import script from "./drawRadarCanvas2v.vue?vue&type=script&lang=js&"
export * from "./drawRadarCanvas2v.vue?vue&type=script&lang=js&"
import style0 from "./drawRadarCanvas2v.vue?vue&type=style&index=0&id=03a36fcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a36fcd",
  null
  
)

export default component.exports